import React from 'react';
import styled from 'styled-components/macro';
import { colorCoreBlack900Base } from '@yme/tokens/colors';
import { INDENT } from '@yme/tokens/sizes';
export const WrapperStyled = styled.div `
  display: block;
  box-sizing: border-box;

  ${({ bottomIndent = INDENT.xxxs }) => bottomIndent && `margin-bottom: ${bottomIndent};`}

  ${({ textColor }) => textColor && `color: ${textColor}`};

  span.show-more-less-clickable {
    ${({ isButtonVisible }) => !isButtonVisible && 'display: none;'}

    color: ${({ buttonColor = colorCoreBlack900Base }) => buttonColor};

    font-weight: 500;
    text-decoration: none;
  }
`;
const WrapperComponentStyled = styled.div `
  width: 100%;
`;
export const ComponentHolderStyled = styled(({ wrapper: WrapperComponent, children }) => (React.createElement(WrapperComponent, { as: WrapperComponentStyled }, children))) ``;
